import { SHARE_CAPITAL_RANGES, type ShareCapitalRange } from '../constants/business-finances';

const shareCapitalRangeSet = new Set<string>(SHARE_CAPITAL_RANGES);

export function isShareCapitalRange(value: string): value is ShareCapitalRange {
  return shareCapitalRangeSet.has(value);
}

export function toShareCapitalRange(value: string | null | undefined): ShareCapitalRange | null {
  if (typeof value !== 'string' || !isShareCapitalRange(value)) return null;
  return value;
}
